import { AlgoliaStoreData, StoreAddress } from '@jbhi-fi/apis/src/algolia/types/AlgoliaStoreData';
import { getDistance } from '../../../../utils/location/locationHelper';
import { StoreLocation } from './types';

export const getAggregatedAddress = (storeAddress: StoreAddress): string => {
  const suburb = storeAddress?.Suburb ? storeAddress.Suburb.trim() : '';
  const state = storeAddress?.State ? storeAddress.State.trim() : '';
  const postcode = storeAddress?.Postcode ? storeAddress.Postcode.trim() : '';

  const comma = suburb && (state || postcode) ? ',' : '';
  const spaceBeforeState = suburb && state ? ' ' : '';
  const spaceBeforePostcode = suburb || state ? ' ' : '';

  return `${suburb}${comma}${spaceBeforeState}${state}${spaceBeforePostcode}${postcode}`.trim();
};

export const parseAlgoliaStoreData = (algoliaStoreData: AlgoliaStoreData, currentLocation?: any): StoreLocation => {
  return {
    id: algoliaStoreData.databaseId,
    name: algoliaStoreData.storeName,
    storeUrl: algoliaStoreData.url,
    address: algoliaStoreData.storeAddress.Line1,
    suburb: algoliaStoreData.storeAddress.Suburb,
    state: algoliaStoreData.storeAddress.State,
    postcode: algoliaStoreData.storeAddress.Postcode,
    distance: `${getDistance(currentLocation, algoliaStoreData._geoloc)}km`,
    aggregatedAddress: getAggregatedAddress(algoliaStoreData.storeAddress),
    coordinates: { longitude: algoliaStoreData._geoloc.lng, latitude: algoliaStoreData._geoloc.lat },
    openingHours: algoliaStoreData.scheduledTradingHoursForTheComingWeek.map(week => {
      return {
        areNormalTradingHours: week.AreNormalTradingHours,
        closingTime: week.ClosingTime,
        date: week.Date,
        dayOfWeek: week.DayOfWeek,
        isOpen: week.IsOpen,
        openingTime: week.OpeningTime,
        reason: week.Reason,
      };
    }),
  };
};
